import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "content" }

import { trans } from "@/utils/trans";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorPopup',
  props: {
    errors: {}
  },
  emits: ["closeForm", "changeTitle", "setModalHeightAuto"],
  setup(__props: any, { emit: __emit }) {

  const emit = __emit;

  const props = __props;

  const closePopup = () => {
    emit("closeForm");
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.errors, (error, index) => {
          return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(error[0].text || error[0]), 1))
        }), 128))
      ])
    ]),
    _createElementVNode("button", {
      onClick: closePopup,
      class: "btn btn-blue"
    }, _toDisplayString(_unref(trans)("modals.error_popup.popup_btn")), 1)
  ], 64))
}
}

})